// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dAWatUoI4_KOxI {
  display: block;
}
.OKlwSQ0FyvrPMg {
  display: inline-block;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0;
  clear: both;
  overflow: hidden;
  border-radius: 8px;
  background-color: var(--ds-surface-raised, #ffffff);
  text-overflow: ellipsis;
  vertical-align: top;
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
@media print {
  .OKlwSQ0FyvrPMg {
    display: block;
    clear: none;
    overflow: visible;
  }
}
.OKlwSQ0FyvrPMg .wjoaa5M7eUVVuW {
  min-height: 40px;
}
.OKlwSQ0FyvrPMg .Tt9w9y9sSmCNSj {
  padding: 8px 12px;
}
.OKlwSQ0FyvrPMg .UsFZdUsj8up1NB {
  min-height: 1.5rem;
  padding: 6px 12px;
}
.OKlwSQ0FyvrPMg p {
  text-overflow: ellipsis;
  word-wrap: break-word;
}
.OKlwSQ0FyvrPMg img {
  max-width: 100%;
  cursor: pointer;
}
.OKlwSQ0FyvrPMg pre {
  max-height: 516px;
}
.OKlwSQ0FyvrPMg img:last-child,
.OKlwSQ0FyvrPMg p:last-child,
.OKlwSQ0FyvrPMg pre:last-child {
  margin-bottom: 0;
}
.OKlwSQ0FyvrPMg a {
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.OKlwSQ0FyvrPMg a a {
  color: var(--ds-link, #0c66e4);
}
.OKlwSQ0FyvrPMg ._qKWC8hsRYb03d a {
  color: var(--ds-link, #0c66e4);
}
.OKlwSQ0FyvrPMg ._qKWC8hsRYb03d a:hover {
  text-decoration: underline;
}
.OKlwSQ0FyvrPMg .emoji {
  width: 18px;
  height: 18px;
  vertical-align: text-bottom;
}
.OKlwSQ0FyvrPMg .atMention {
  font-weight: bold;
}
.OKlwSQ0FyvrPMg .atMention.me {
  color: var(--ds-text-brand, #0c66e4);
}
.MVUM3U5pPDzQ9w {
  border-radius: 3px;
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: none;
  font-size: 12px;
  line-height: 15px;
}
.MVUM3U5pPDzQ9w:hover {
  background-color: var(--ds-surface-raised, #ffffff);
}
.WB8EjxpBAw9olv {
  width: 100%;
}
.GlUfiC16CgCUBJ {
  display: block;
  position: absolute;
  z-index: 1;
  right: 0;
  bottom: 30px;
  left: 0;
  height: 40px;
  background: linear-gradient(to bottom, var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0)), var(--ds-surface-raised, #ffffff));
}
.MVUM3U5pPDzQ9w .GlUfiC16CgCUBJ {
  height: 30px;
  background: linear-gradient(to bottom, var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0)), var(--ds-surface-raised, #ffffff));
}
.j7O99xUCy1biQi {
  position: relative;
  max-height: 200px;
}
.j7O99xUCy1biQi.MVUM3U5pPDzQ9w {
  max-height: 85px;
}
.Qr4pRJCBmkQGsy {
  position: absolute;
  z-index: 1;
  bottom: 0;
  height: 30px;
  margin: 0;
  background: var(--ds-surface-raised, #ffffff);
}
.Qr4pRJCBmkQGsy:hover {
  background: var(--ds-surface-raised, #ffffff);
}
.MVUM3U5pPDzQ9w .Qr4pRJCBmkQGsy {
  background: var(--ds-surface-raised, #ffffff);
  font-size: 12px;
}
.MVUM3U5pPDzQ9w .Qr4pRJCBmkQGsy:hover {
  background: var(--ds-surface-raised, #ffffff);
}
.tKmMYdz8k4bjIm {
  position: relative;
  z-index: 1;
  height: 30px;
  margin: 0;
  background: var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0));
}
.tKmMYdz8k4bjIm:hover {
  background: var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0));
}
.MVUM3U5pPDzQ9w .tKmMYdz8k4bjIm {
  font-size: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commentContainer": `dAWatUoI4_KOxI`,
	"comment": `OKlwSQ0FyvrPMg`,
	"collapsedComment": `wjoaa5M7eUVVuW`,
	"currentComment": `Tt9w9y9sSmCNSj`,
	"reducedRendererPadding": `UsFZdUsj8up1NB`,
	"naturalLinkStyling": `_qKWC8hsRYb03d`,
	"reactionAdded": `MVUM3U5pPDzQ9w`,
	"isFullWidth": `WB8EjxpBAw9olv`,
	"truncationOverlay": `GlUfiC16CgCUBJ`,
	"isTruncated": `j7O99xUCy1biQi`,
	"showMoreButton": `Qr4pRJCBmkQGsy`,
	"showLessButton": `tKmMYdz8k4bjIm`
};
export default ___CSS_LOADER_EXPORT___;
